import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-project-diagram-resets',
  templateUrl: './project-diagram-resets.component.html',
  styleUrls: ['./project-diagram-resets.component.scss']
})
export class ProjectDiagramResetsComponent implements OnInit {

  form: FormGroup = this.fb.group({
    fase: ['', Validators.required],
    vobo: ['', Validators.required],
    comentario: ['', Validators.required],
    id_diagrama : [0, Validators.required],
    fase_nombre : ['', Validators.required],
    usr_art : ['', Validators.required],  
    pha_vobos: [[]],
    arte: [false],
    id_arte_compartido: [null]
  });
  fases: any[] = [];
  vobos: any[] = [];
  allvobos : any [] = [];
  id_diagrama : number = 0;
  usr_art : any [] = [];
  artesCompartidos: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<ProjectDiagramResetsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private projectsS: ProjectsService,
    private main: MainService,
    private fb: FormBuilder
  ) {
    this.fases = data?.fases || [];
    this.allvobos = data?.vobos || [];
    this.usr_art = data?.usr_art || [];
    this.artesCompartidos = Array.isArray(data?.artes_compartidos) ? data.artes_compartidos : [];
    
    this.id_diagrama = data?.id_diagrama || 0;

    console.log(this.fases);
         console.log(this.allvobos);
  }

  ngOnInit(): void {
    const fasesdisponibles = new Set(
      this.allvobos
        .filter(voboList => voboList.vobos && voboList.vobos.some((v: any) => v.status === 1))
        .map(voboList => voboList.id)
    );
    this.fases = this.fases.filter(fase => fasesdisponibles.has(fase.id));

    if (this.fases.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Aviso',
        text: 'No hay VoBos para resetear en ninguna fase de esta diagramación.'
      }).then(() => {
      
      });
      this.dialogRef.close();
    }

    this.form.get('id_diagrama')?.setValue(this.id_diagrama);
    this.form.get('usr_art')?.setValue(this.usr_art);
    this.form.get('fase')?.valueChanges.subscribe(this.onSelectFaseChange.bind(this));
  }

  enviar(): void {
     this.form.get('pha_vobos')?.setValue(this.vobos);
     
    if (this.form.valid) {
      console.log(this.form.value);
        this.main.ShowLoading();
      this.projectsS.resetVobo(this.form.value).subscribe(
        (result:any) => {
          this.main.HideLoading();
          if(result?.message == 'Success'){
            Swal.fire({
              icon: 'success',
              title: 'Completado',
              text: 'Se ha efectuado la acción correctamente'          
            }).then(s=>{
           
            });
          }
         },
         (err:any) => {
          this.main.HideLoading();
          console.log(err);
  
            Swal.fire({
              icon: 'error',
              title: 'Error al resetear',
              text: 'Ocurrió un error al resetear el VoBo.'
            });
          
        }
      );

      this.dialogRef.close(this.form.value);
    }
  }

  onSelectFaseChange() {
    const selectedFaseId = this.form.get('fase')?.value;
    this.form.get('vobo')?.reset('');
    this.vobos = [];
    
    let fase_nombre = this.fases.find(item => item.id === selectedFaseId );

    this.form.get('fase_nombre')?.setValue(fase_nombre?.name);
    const arteCompartido = this.artesCompartidos
      .filter((arte: any) => Number(arte.id_phase || arte.id_fase) === Number(selectedFaseId))
      .sort((a: any, b: any) => Number(b.id) - Number(a.id))[0];
    this.form.get('id_arte_compartido')?.setValue(arteCompartido?.id || null);
    const faseData = this.allvobos.find(item => item.id === selectedFaseId); 
    if (faseData && faseData.vobos) {
      const vobosAceptados = faseData.vobos.filter((vobo: any) => vobo.status === 1);
      if (vobosAceptados.length > 0) {
        this.vobos = vobosAceptados;

        this.form.get('pha_vobos')?.setValue(this.vobos);
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Aviso',
          text: 'No hay VoBos para resetear en esa fase.'
        });
      }
    }
  }

}
